import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { Chat } from '../../bayadic-shared-models/chat/Chat';
import { Item } from '../../bayadic-shared-models/classes/item/Item';
import { PrimarySettings } from '../../bayadic-shared-models/classes/system/settings/PrimarySettings';
import { User } from '../../bayadic-shared-models/classes/user/User';
import { Friend } from '../../bayadic-shared-models/classes/user/friend/Friend';
import { Collection } from '../../bayadic-shared-models/collection/Collection';

@Injectable()
export class StorageManagerProvider {
    public phone: Object;
    public account: Object;
    public settings: Object;
    public result: any;
    public db: any;
    public static get accountAcctivated() { return "accountActivated" };
    constructor(public storage: Storage) {
        //      this.createDatabase();
        this.storage.create();

    }
    async get(key: string) {
        const data = await this.storage.get(key);
        return data;
    }
    //  createDatabase(){
    //        this.logger.debug("creating database");
    //        this.sqlite.create({
    //          name: 'app_database.db',
    //          location: 'default'
    //        }).then((db: SQLiteObject) => {
    //
    //            this.logger.debug("creating---tabale");
    //            db.executeSql('create table user(name VARCHAR(32))', {})
    //              .then(() => this.logger.debug('Executed SQL'))
    //              .catch(e => this.logger.debug(e));
    //
    //
    //          }).catch(e => this.logger.debug(e));
    //
    //    }
    async set(key: string, param: string | number | boolean | User | Chat | Item[] | Friend[] | PrimarySettings | Collection[] | number[] | Item) {
        await this.storage.set(key, param);
    }
    isAccountActivated() {
        return new Promise(resolve => { resolve(this.get(StorageManagerProvider.accountAcctivated)) });
    }
    activateAccount() {
        return this.set(StorageManagerProvider.accountAcctivated, true);
    }
    deactivateAccount() {
        return this.set(StorageManagerProvider.accountAcctivated, false);
    }
    getAccount() {
        this.getSetting("account");
        if (this.settings["account"] != undefined)
            this.account = this.settings["account"];
        else
            this.account = { activated: false }
    }
    loadDefaultSettingsFor(key: string | number) {
        this.settings[key] = { intialized: false };
    }
    setSetting(key: string | number, param: any) {
        this.settings[key] = param;
    }
    setKeyData(key: string | number, data: any) {
        //      this.settings[key] = {initialized : true};
        this.settings[key] = data;
    }
    getSetting(key: string) {
        var self = this;
        this.storage.get("settings").then((data) => {
            if (data != null) {
                var settings = JSON.parse(data);
            }
        });
    }

    async clearAllStorage() {
        await this.storage.clear();
    }

    async clearAllDatabases() {
        const databases = await indexedDB.databases();
        for (const db of databases) {
            if (db.name) {
                await new Promise((resolve) => {
                    const request = indexedDB.deleteDatabase(db.name);
                    request.onsuccess = () => resolve(true);
                    request.onerror = () => resolve(false);
                });
            }
        }
    }
}
